/**
 * Full-bleed photographic band — a visual "chapter break" between sections
 * that keeps long pages engaging without repeating card/text patterns.
 */
export default function ImageBand({
  testid,
  image,
  caption,
  alt = "",
  position = "center",
}) {
  return (
    <section
      data-testid={testid}
      className="relative h-64 sm:h-80 md:h-[420px] overflow-hidden"
    >
      <img
        src={image}
        alt={alt}
        loading="lazy"
        className="absolute inset-0 w-full h-full object-cover slow-scale"
        style={{ objectPosition: position }}
      />
      <div className="absolute inset-0 bg-black/10" aria-hidden />
      {caption && (
        <div className="absolute bottom-4 left-4 md:left-8 bg-black/80 backdrop-blur-md px-3 py-1.5 text-[10px] tracking-[0.2em] uppercase text-white">
          {caption}
        </div>
      )}
    </section>
  );
}
